import styled from 'styled-components';

export const BarChartContainer = styled.div`
  padding: 0 10px 10px;
  background: ${({ theme }) => theme.colors.white};
`;
